export const ROUTE_PATHS = {
  root: "/",
  notFound: "/not-found",
  dashboard: "/dashboard",
  packages: "/packages",
  flashcard: "/flashcard",
  flashcardDecks: "/flashcard/decks",
  flashcardDecksForm: "/flashcard/decks/:mode",
  flashcardQuestions: "/flashcard/questions",
  flashcardTopic: "/flashcard/topics",
  flashcardSubTopic: "/flashcard/topics/:topicId/sub-topics",
  packageForm: "/packageForm",
  finalTestForm: "/finalTestForm",
  finalTest: "/finalTest",
  programs: "/programs",
  programsEdit: "/programsEdit",
  login: "/login",
  admins: "/admins",
  authors: "/authors",
  editors: "/editors",
  directors: "/directors",
  categories: "/categories",
  books: "/books",
  forgotPassword: "/forgot-password",
  changePassword: "/change-password",
  createPassword: "/create-password",
  addBook: "/add-book",
  editBook: "/edit-book",
  bookDetails: "/book",
  supplementaries: "/supplementaries",
  addSupplementary: "/add-supplementary",
  editSupplementary: "/edit-supplementary",
  supplementaryDetails: "/supplementary",
  quizzes: "/quizzes",
  addQuiz: "/add-quiz",
  surveys: "/surveys",
  addSurvey: "/add-survey",
  editSurvey: "/edit-survey",
  surveysDetails: "/surveys",
  surveysStatistics: "/surveys-statistics",
  editQuiz: "/edit-quiz",
  importQuizzes: "/import-quizzes",
  viewQuiz: "/view-quiz",
  preTestPostTest: "/tests",
  addPreTestPostTest: "/add-test",
  editPreTestPostTest: "/edit-test",
  preTestPostTestDetails: "/test",
  userTestReports: "/test-report",
  registeredUsers: "/registered-users",
  institute: "/institute",
  addInstitution: "/add-institute",
  editInstitute: "/edit-institute",
  promoCodes: "/promocodes",
  addPromoCodes: "/add-promocode",
  promoCodeDetails: "/promocode",
  institution: "/institution",
  institutionDetails: "/institute"
};
